"use strict"

import React, { useState } from "react"
import PropTypes from "prop-types"
import { Modal, Button } from "react-bootstrap"
import { FormattedMessage, useIntl } from "react-intl"

import { API_STATUS } from "../../../../shared_components/widgets/utils"
import { addNewObject } from "../../../../Loaders"
import { logToServer } from "../../../../ErrorBoundary"
import { LocaleFormattedDate } from "../../../internationalization/LocaleFormatted"

export default function ModalReceiveProcurementItem({ procurement_item = {}, onHide, onSuccess, show }) {
  const intl = useIntl()
  const [status_submit, setStatusSubmit] = useState(null)
  const [formValues, setFormValues] = useState({
    actual_quantity_received: procurement_item.quantity,
  })

  const onChangeValue = (event) => {
    setFormValues({
      ...formValues,
      [event.target.name]: event.target.value,
    })
  }

  const onSubmit_receiveItem = (event) => {
    event.preventDefault()
    setStatusSubmit(API_STATUS.LOADING)

    addNewObject(`/laboratory/inventory/procurement-item/${procurement_item.id}/receive/`, formValues)
      .then((data) => {
        setStatusSubmit(API_STATUS.SUCCESS)
        onSuccess({
          procurement_item: procurement_item,
          response: data,
        })
      })
      .catch((error) => {
        logToServer(error)
        console.error(error)
        alert(intl.formatMessage({ id: "inventory.unable_to_submit" }))
        setStatusSubmit(null)
      })
  }

  return (
    <Modal size={"lg"} show={show} onHide={onHide} backdrop={"static"} keyboard={true}>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className={"fa fa-thumbs-o-up"} />
          &nbsp;&nbsp;
          <FormattedMessage id={"inventory.receive-procurement-item"} />
          &nbsp;&nbsp;
          {"#" + procurement_item.id}: {procurement_item.name} ({procurement_item.inventory_type.name})
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form name={"form_receive_item"} style={{ width: "700px" }} onSubmit={onSubmit_receiveItem}>
          <table className={"table table-sm"}>
            <tbody>
              <tr>
                <td style={{ width: "350px" }}>
                  <label>
                    <FormattedMessage id={"general.name"} />
                  </label>
                  :{" "}
                </td>
                <td>{procurement_item.name}</td>
              </tr>
              <tr>
                <td>
                  <label>
                    <FormattedMessage id={"general.description"} />
                  </label>
                  :{" "}
                </td>
                <td>{procurement_item.description}</td>
              </tr>
              <tr>
                <td>
                  <label>
                    <FormattedMessage id={"general.type"} />
                  </label>
                  :{" "}
                </td>
                <td>{procurement_item.inventory_type.name}</td>
              </tr>
              <tr>
                <td>
                  <label>
                    <FormattedMessage id={"stock.uom"} />
                  </label>
                  :{" "}
                </td>
                <td>{procurement_item.uom}</td>
              </tr>
              <tr>
                <td>
                  <label>
                    <FormattedMessage id={"stock.lot"} />
                  </label>
                  :{" "}
                </td>
                <td>{procurement_item.lot_no}</td>
              </tr>
              <tr>
                <td>
                  <label>
                    <FormattedMessage id={"stock.quantity"} />
                  </label>
                  :{" "}
                </td>
                <td>{procurement_item.quantity}</td>
              </tr>
              <tr>
                <td>
                  <label>
                    <FormattedMessage id={"stock.retest_date"} />
                  </label>
                  :{" "}
                </td>
                <td>
                  <LocaleFormattedDate
                    date={procurement_item.retest_date}
                    shouldParse={true}
                    showTime={false}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <FormattedMessage id={"inventory.expected_receive_date"} />
                  </label>
                  :{" "}
                </td>
                <td>
                  <LocaleFormattedDate
                    date={procurement_item.expected_receive_date}
                    shouldParse={true}
                    showTime={false}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <FormattedMessage id={"inventory.actual_quantity_received"} />
                  </label>{" "}
                  *:{" "}
                </td>
                <td>
                  <input
                    type={"number"}
                    name={"actual_quantity_received"}
                    className={"form-control form-control-sm"}
                    style={{ width: "170px" }}
                    required={true}
                    min={"1"}
                    max={procurement_item.quantity}
                    value={formValues.actual_quantity_received}
                    onChange={onChangeValue}
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <div align={"center"}>
            {status_submit === API_STATUS.LOADING && (
              <div>
                <div className="spinner-border text-primary text-center" role="status" />
                &nbsp;
                <FormattedMessage id={"general.saving"} />
                ...
              </div>
            )}

            {status_submit === null && (
              <Button variant={"primary"} type={"submit"}>
                <FormattedMessage id={"general.submitButton"} />
              </Button>
            )}
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant={"outline-primary"} onClick={onHide} style={{ display: "flex", float: "right" }}>
          <FormattedMessage id={"general.closeButton"} />
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

ModalReceiveProcurementItem.propTypes = {
  procurement_item: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
}
